export const defaultSortKey = 'id';

// NORMAL:   ;  DETAIL:  ; CHECKOUT:  ;
const InvoiceListType = {
  NORMAL: 'normal',
  DETAIL: 'detail',
  CHECKOUT: 'checkout',
};

export default InvoiceListType;
